
import { defineComponent, nextTick, onMounted, reactive, ref } from 'vue';
import { parseNumberOrZero } from '@/utils/illuminate';
import { message } from 'ant-design-vue';
import { useStore } from 'vuex';
import { useFinance } from '@/views/finance/parts/utils';
import { request } from '@/utils/request';
import { createApiUrl, firstError, isValidateError, toApiUnit } from '@/utils/utils';

const defaultFormData = {
  otherSideEnterpriseId: undefined,
  transferAmount: '',
};

export default defineComponent({
  name: 'TransformModal',
  emits: ['complete'],
  setup(props, ctx) {
    const store = useStore();
    const financeState = useFinance();
    const visible = ref(false);

    const formData = reactive({
      ...defaultFormData,
    });

    const formRules = {
      otherSideEnterpriseId: [{
        validator(rule: any, value: any) {
          return value ? Promise.resolve() : Promise.reject('请选择转入公司');
        },
        trigger: 'blur',
      }],
      transferAmount: [
        { required: true, message: '请输入转账金额', trigger: 'blur' },
        {
          validator(rule: any, value: any) {
            const valNum = parseNumberOrZero(value);
            return valNum <= 0
              ? Promise.reject('转账金额必须大于 0')
              : valNum > financeState.financeDetail.value.availableAmount
                ? Promise.reject('转账金额不可大于"可转金额"')
                : Promise.resolve();
          },
          trigger: 'blur',
        },
      ],
    };

    const transfer = () => {
      visible.value = true;
      financeState.loadFinanceDetail();
    };

    const formRef = ref<any>(null as any);
    const submiting = ref(false);

    const onCancel = () => {
      Object.assign(formData, defaultFormData);
      formRef.value.clearValidate();
    };

    const onSubmit = async () => {
      try {
        await formRef.value.validate();
        await request.post(createApiUrl('/newlinkSass/finance/enterprise/transfer'), {
          ...formData,
          enterpriseId: store.state.User!.enterprise!.enterpriseId,
          transferAmount: toApiUnit(formData.transferAmount),
        });
      } catch (e: Error & any) {
        return message.error(isValidateError(e.message) ? firstError(e) : e.message);
      }

      message.success('转账完成');
      visible.value = false;
      ctx.emit('complete');
      onCancel();
    };

    return {
      ...financeState,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },

      formData,
      formRules,

      visible,
      transfer,

      formRef,
      submiting,
      onSubmit,
      onCancel,
    };
  },
});
